import {
  Component,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {AbstractComponent} from "../abstract.component";
import { NgbDropdown } from "@ng-bootstrap/ng-bootstrap";
import {isPlatformBrowser} from "@angular/common";
import { BreakpointObserver } from '@angular/cdk/layout';
import { trigger, transition, style, animate } from "@angular/animations";


@Component({
  selector: 'app-filter-item',
  templateUrl: './filter-item.component.html',
  styleUrls: ['./filter-item.component.scss'],
  animations: [
    trigger('slideUpDown', [
      transition(':enter', [
        style({ transform: 'translateY(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateY(0%)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ transform: 'translateY(100%)', opacity: 1 }))
      ])
    ])
  ]
})
export class FilterItemComponent extends AbstractComponent {

  @Input() title: string = "";
  @Input() items: FilterItem[] = [];
  @Input() id: string = "";
  @Input() isMultiSelect: boolean = true;
  @Input() allowSearchItems: boolean = false;

  @Output() onChange = new EventEmitter<FilterItem[]>();

  @ViewChild('desktopDropdown', { static: false }) desktopDropdown?: NgbDropdown;

  isBrowser: boolean = false;
  isDesktop: boolean = false;
  isMobileFilterOpen = false;

  localStateItems: FilterItem[] = [];
  filteredItems: FilterItem[] = [];
  searchText?: string;


  constructor(private breakpointObserver: BreakpointObserver,
              @Inject(PLATFORM_ID) private platformId: Object) {
    super();
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.subscriptions.push(
          this.breakpointObserver
              .observe([`(max-width: 991.98px)`])
              .subscribe(result => {
                this.isDesktop = !result.matches;
              })
      );
    }
  }

  @HostListener('window:resize')
  onResize() {
    if (this.isBrowser) {
      this.desktopDropdown?.close();
    }
  }


  handleInput(input: string): void {
    const trimmed = input?.trim().toLowerCase() || '';
    this.searchText = trimmed;
    this.setFilteredItems();
  }

  setFilteredItems() {
    if (this.searchText && this.allowSearchItems) {
      this.filteredItems = [...this.localStateItems.filter(i => i.label?.toLowerCase().includes(this.searchText!)
      )];
    }
    else {
      this.filteredItems = [...this.localStateItems];
    }
  }

  toggleItem(item: FilterItem) {
    if (this.isMultiSelect) {
      item.selected = !item.selected;
    } else {
      this.localStateItems.forEach(f => f.selected = false);
      item.selected = true;
    }
    this.setFilteredItems();
    const selected = this.localStateItems.filter(item => item.selected);

    if (this.isDesktop) {
      this.onChange.emit(selected);
    }
  }

  onOpenMobileFilter() {
    this.isMobileFilterOpen = true;
    this.localStateItems = this.items.map(f => ({ ...f }));
    this.searchText = undefined;
    this.setFilteredItems();
    document.body.classList.add('no-scroll');
  }

  onDesktopDropdownOpen(isOpen: boolean) {
    if (isOpen) {
      this.localStateItems = this.items.map(f => ({ ...f }));
      this.searchText = undefined;
      this.setFilteredItems();
    }
  }

  onApply() {
    const selected = this.localStateItems.filter(item => item.selected);
    this.onChange.emit(selected);
    this.onFilterClose();
  }

  onClear() {
    this.onChange.emit([]);
    this.onFilterClose();
  }

  onFilterClose(): void {
    this.desktopDropdown?.close();
    this.isMobileFilterOpen = false;
    document.body.classList.remove('no-scroll');
  }

  onClose() {
    this.onFilterClose();
  }
}

export class FilterItem {
  constructor(public id?: number,
              public label?: string,
              public labelKey?: string,
              public selected?: boolean
  ) {
  }
}
